// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.desafio {
  background: linear-gradient(135deg, #fff5f0 0%, #f8f9fa 100%);
  padding: 100px 20px;
}

.desafio .section-title {
  margin-bottom: 60px;
  color: #5B4B8A;
}

.desafio-intro {
  max-width: 800px;
  margin: 0 auto 70px;
  text-align: justify;
}

.desafio-intro p {
  font-size: 1.15em;
  line-height: 1.8;
  color: #666;
  font-weight: 500;
}

.desafio-problemas {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 40px;
  margin-bottom: 60px;
}

.problema-card {
  background: white;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  border-top: 6px solid #FF8C00;
  transition: all 0.4s ease;
}

.problema-card:hover {
  box-shadow: 0 12px 35px rgba(255, 140, 0, 0.15);
  transform: translateY(-5px);
}

.problema-card h3 {
  color: #FF8C00;
  font-size: 1.4em;
  margin-bottom: 30px;
  text-align: center;
  font-family: 'Playfair Display', serif;
  font-weight: 700;
}

.problema-stats {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.stat-item {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.stat-bar-wrapper {
  width: 100%;
  height: 28px;
  background: #f0f0f0;
  border-radius: 6px;
  overflow: hidden;
}

.stat-bar {
  height: 100%;
  background: linear-gradient(90deg, #FF8C00 0%, #d96f00 100%);
  transition: width 0.8s cubic-bezier(0.23, 1, 0.320, 1);
  border-radius: 6px;
}

.stat-label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.9em;
  color: #666;
}

.stat-valor {
  font-weight: 700;
  color: #FF8C00;
  font-size: 1.1em;
}

.desafio-conclusion {
  background: linear-gradient(135deg, rgba(255, 140, 0, 0.1) 0%, rgba(91, 75, 138, 0.1) 100%);
  padding: 40px;
  border-radius: 12px;
  border-left: 5px solid #FF8C00;
  max-width: 900px;
  margin: 0 auto;
}

.desafio-conclusion p {
  font-size: 1.1em;
  line-height: 1.8;
  color: #333;
  margin: 0;
  text-align: left;
}

.desafio-conclusion strong {
  color: #FF8C00;
  font-weight: 700;
}

@media (max-width: 768px) {
  .desafio {
    padding: 60px 15px;
  }

  .desafio-intro p {
    font-size: 1em;
  }

  .desafio-problemas {
    gap: 25px;
  }

  .problema-card {
    padding: 25px;
  }

  .problema-card h3 {
    font-size: 1.2em;
  }

  .desafio-conclusion {
    padding: 25px;
  }

  .desafio-conclusion p {
    font-size: 0.95em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Desafio.css"],"names":[],"mappings":"AAAA;EACE,6DAA6D;EAC7D,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,4DAA4D;EAC5D,sDAAsD;EACtD,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,2FAA2F;EAC3F,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".desafio {\r\n  background: linear-gradient(135deg, #fff5f0 0%, #f8f9fa 100%);\r\n  padding: 100px 20px;\r\n}\r\n\r\n.desafio .section-title {\r\n  margin-bottom: 60px;\r\n  color: #5B4B8A;\r\n}\r\n\r\n.desafio-intro {\r\n  max-width: 800px;\r\n  margin: 0 auto 70px;\r\n  text-align: justify;\r\n}\r\n\r\n.desafio-intro p {\r\n  font-size: 1.15em;\r\n  line-height: 1.8;\r\n  color: #666;\r\n  font-weight: 500;\r\n}\r\n\r\n.desafio-problemas {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\r\n  gap: 40px;\r\n  margin-bottom: 60px;\r\n}\r\n\r\n.problema-card {\r\n  background: white;\r\n  padding: 40px;\r\n  border-radius: 12px;\r\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);\r\n  border-top: 6px solid #FF8C00;\r\n  transition: all 0.4s ease;\r\n}\r\n\r\n.problema-card:hover {\r\n  box-shadow: 0 12px 35px rgba(255, 140, 0, 0.15);\r\n  transform: translateY(-5px);\r\n}\r\n\r\n.problema-card h3 {\r\n  color: #FF8C00;\r\n  font-size: 1.4em;\r\n  margin-bottom: 30px;\r\n  text-align: center;\r\n  font-family: 'Playfair Display', serif;\r\n  font-weight: 700;\r\n}\r\n\r\n.problema-stats {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 25px;\r\n}\r\n\r\n.stat-item {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.stat-bar-wrapper {\r\n  width: 100%;\r\n  height: 28px;\r\n  background: #f0f0f0;\r\n  border-radius: 6px;\r\n  overflow: hidden;\r\n}\r\n\r\n.stat-bar {\r\n  height: 100%;\r\n  background: linear-gradient(90deg, #FF8C00 0%, #d96f00 100%);\r\n  transition: width 0.8s cubic-bezier(0.23, 1, 0.320, 1);\r\n  border-radius: 6px;\r\n}\r\n\r\n.stat-label {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  font-size: 0.9em;\r\n  color: #666;\r\n}\r\n\r\n.stat-valor {\r\n  font-weight: 700;\r\n  color: #FF8C00;\r\n  font-size: 1.1em;\r\n}\r\n\r\n.desafio-conclusion {\r\n  background: linear-gradient(135deg, rgba(255, 140, 0, 0.1) 0%, rgba(91, 75, 138, 0.1) 100%);\r\n  padding: 40px;\r\n  border-radius: 12px;\r\n  border-left: 5px solid #FF8C00;\r\n  max-width: 900px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.desafio-conclusion p {\r\n  font-size: 1.1em;\r\n  line-height: 1.8;\r\n  color: #333;\r\n  margin: 0;\r\n  text-align: left;\r\n}\r\n\r\n.desafio-conclusion strong {\r\n  color: #FF8C00;\r\n  font-weight: 700;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .desafio {\r\n    padding: 60px 15px;\r\n  }\r\n\r\n  .desafio-intro p {\r\n    font-size: 1em;\r\n  }\r\n\r\n  .desafio-problemas {\r\n    gap: 25px;\r\n  }\r\n\r\n  .problema-card {\r\n    padding: 25px;\r\n  }\r\n\r\n  .problema-card h3 {\r\n    font-size: 1.2em;\r\n  }\r\n\r\n  .desafio-conclusion {\r\n    padding: 25px;\r\n  }\r\n\r\n  .desafio-conclusion p {\r\n    font-size: 0.95em;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
